'use strict'

import axios from 'axios'

const { VUE_APP_COMMS_URL } = process.env

export default async ({ jwt }) => axios({
  method: 'delete',
  headers: {
    Authorization: jwt
  },
  url: `${VUE_APP_COMMS_URL}/user_request_delete_all`,
  timeout: 8000
})
